import React from "react";
import { GridGenerator, FormSelect } from "@actinc/dls/components";
import { Box } from "@mui/material";
import { useFormContext } from "react-hook-form";

import {
  ControlledFormEditor,
  ControlledFormInput,
} from "../../../../components";

const ExtendedTextInteractionForm = ({
  index,
  interaction,
  readonly,
  update,
}) => {
  const namePrefix = `item.interactions[${index}]`;
  // console.debug(
  //   "ExtendedTextInteractionForm - index %s, interaction %o",
  //   index,
  //   interaction
  // );

  const { control, getValues } = useFormContext();

  const getExpectedLines = (expectedLength) => {
    if (!expectedLength) return null;
    if (expectedLength < 1000) return 4;
    if (expectedLength < 10000) return 10;
    return 35;
  };

  const onLengthChange = (e) => {
    const value = parseInt(e.target.value);
    if (Number.isInteger(value))
      update(index, {
        ...getValues(namePrefix),
        expectedLines: getExpectedLines(value),
      });
  };
  const onSizeChange = (e) => {
    update(index, {
      ...getValues(namePrefix),
      expectedLength: e.target.value,
      expectedLines: getExpectedLines(e.target.value),
    });
  };

  const standardSizesOptions = [
    {
      label: `Short Answer - 360`,
      value: 360,
    },
    {
      label: `Short Answer - 450`,
      value: 450,
    },
    {
      label: `Short Answer - 600`,
      value: 600,
    },
    {
      label: `Extended Response - 1000`,
      value: 1000,
    },
    {
      label: `Extended Response - 1200`,
      value: 1200,
    },
    {
      label: `Writing Prompt - 10000`,
      value: 10000,
    },
  ];

  if (!getValues(`${namePrefix}.identifier`)) return null;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
      }}
    >
      <GridGenerator
        groups={[
          [
            {
              children: (
                <ControlledFormInput
                  control={control}
                  defaultValue={interaction.expectedLength}
                  id={`${namePrefix}.expectedLength`}
                  label="Maximum Characters"
                  multiline={false}
                  name={`${namePrefix}.expectedLength`}
                  onBlur={onLengthChange}
                  readonly={readonly}
                  rules={{
                    pattern: {
                      message: "This field must contain a valid number",
                      value: /^\d+$/,
                    },
                    required: true,
                  }}
                />
              ),
              key: `${namePrefix}.expectedLength`,
            },
            {
              children: (
                <FormSelect
                  formControlProps={{
                    margin: "none",
                    size: "small",
                    sx: {
                      marginBottom: 2,
                      "& .MuiInputBase-root": {
                        marginTop: 0,
                      },
                    },
                  }}
                  fullWidth={true}
                  id={`standardSizes`}
                  label="Standard Size"
                  name={`standardSizes`}
                  onChange={(e) => !readonly && onSizeChange(e)}
                  options={standardSizesOptions}
                  value={""}
                  variant="standard"
                />
              ),
              key: `standardSizes`,
            },
          ],
        ]}
      />
      <ControlledFormEditor
        control={control}
        id={`${namePrefix}.scoringCriteria`}
        label="Scoring Criteria"
        name={`${namePrefix}.scoringCriteria`}
        options={[]}
        readonly={readonly}
      />
    </Box>
  );
};

export { ExtendedTextInteractionForm };
